import { render, staticRenderFns } from "./thirdPartyTermsPopup.vue?vue&type=template&id=a76ad9bc&scoped=true&"
import script from "./thirdPartyTermsPopup.vue?vue&type=script&lang=js&"
export * from "./thirdPartyTermsPopup.vue?vue&type=script&lang=js&"
import style0 from "./thirdPartyTermsPopup.vue?vue&type=style&index=0&id=a76ad9bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76ad9bc",
  null
  
)

export default component.exports